<template>
    <div :style="{'background':'white','overflow-y':'auto','height':'tabHeight','margin-top':'2px'}">
        <!-- <div style="font-weight:700; width:100%; line-height:40px;height:40px;  border-bottom:2px solid #389;text-align:center;font-size:16px;color:#389">单品净利润测算表</div> -->
        <div style=" display:flex; width:100%; line-height:35px;height:35px; background:#808695;color:white;border-left:3px solid #409eff">
         
            <span style="font-size:12px; font-weight:600;margin-left:8px"> 历史（真实）毛利一览表</span>
            <!-- <i class="iconfont icon-kaoqinguanli1" style="color:#FFF;font-size:14px;margin-left:15px;margin-right:6px"></i>
            <span style="font-size:12px;  font-weight:600; margin-right:3px">交易月份</span>
            <el-date-picker :editable="false" :clearable="false" type="month" size="small"  v-model="frdttm"  value-format="yyyy-MM" style="width:130px" ></el-date-picker>  
            <span style="font-size:12px;  font-weight:600;margin-left:5px;margin-right:5px">-</span>
            <el-date-picker :editable="false" :clearable="false" type="month" size="small"  v-model="todttm"  value-format="yyyy-MM" style="width:130px;margin-right:15px;" ></el-date-picker>   -->
            <span style="font-size:12px;  font-weight:600; margin-right:3px;margin-left:25px">ASIN</span>
            <el-input   size="small"  v-model="asinno"  style="width:160px;margin-right:15px;" ></el-input> 
            <span style="font-size:12px;  font-weight:600; margin-right:3px;margin-left:5px">SKU</span>
            <el-input   size="small"  v-model="skuno"  style="width:160px;margin-right:15px;" ></el-input>  
            <span style="font-size:12px;  font-weight:600; margin-right:3px;margin-left:5px">商品编码</span>
            <el-input   size="small"  v-model="matno"  style="width:160px;margin-right:15px;" ></el-input> 
            <el-button size="mini" type="primary" icon="iconfont icon-gaojichazhao2" @click="qryTabData" style="width:70px;height:35px;margin-left:10px; "><span style="margin-left:5px;font-size:12px">查询</span></el-button> 
            <el-button size="mini" type="primary" icon="iconfont icon-shuaxin" @click="refData" style="width:110px;height:35px;margin-left:30px; "><span style="margin-left:5px;font-size:12px">刷新数据</span></el-button> 
        </div> 
         <!-- <div style="line-height:35px;height:35px;border:1px solid #409eef;min-width:200px; display:flex;margin-top:1px">
             <div  v-for="(item,index) in tabArr" :key="index">
                 <div :class="index==tabArr.length-1?'border-right':'border-right'" :style="{'text-align':'center','font-size':'12px','width':`${item.width}`+'px'}">{{item.title}}</div>
             </div>
         </div> -->
         <el-table  :data="tabData" 
              border                            
              size="small"
              :height="200" 
              class="custom-table-border"
              ref="refsum"
              :cell-style="{padding:'2px'}"
              @row-click="rowClick"
              :row-key="getRowKey"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" fixed width="70"></el-table-column>
            <span v-for="(item ) in tabCol" :key="item.key" > 
                <el-table-column  v-if="item.thide==='N' "
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
            </span> 
        </el-table>
        <div style=" display:flex; width:100%; line-height:30px;height:30px;margin-top:2px; background:#808695;color:white;border-left:3px solid #409eff ">
          
            <span style="font-size:12px;margin-left:6px;font-weight:600"> SKU</span>
         </div>
         <el-table  :data="skuData" 
              border                            
              size="small"
              :cell-style="{padding:'2px'}"
              :height="210" 
              class="custom-table-border"
              ref="refsku"
              @row-click="skuClick"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index"  width="55"></el-table-column>
     
            <el-table-column v-for="(item,index ) in skuCol.filter(item=>item.thide=='N')" :key="index" 
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                sortable
                :min-width="item.width">
            </el-table-column> 
 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="130">
                <template slot-scope="scope">
                    <i class="iconfont icon-bianji" style="color:#409eff;font-size:12px; "></i>
                    <el-link  @click="editSku(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px;margin-right:5px;color:#409eff;">编辑</span></el-link>
                    <i class="iconfont icon-xinzeng" style="color:#409eff;font-size:12px; "></i>
                    <el-link  @click="addRec(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px;margin-right:2px;color:#409eff;">新增预测</span></el-link>
                </template>
            </el-table-column>  
        </el-table>
        <!-- 雷达图 ASIN & SKU -->
        <div style="height:250px;display:flex;background:white;margin-top:5px ">
            <div style=" width:50%;display:flex">
                <div style="margin-top:100px;text-align:right;width:200px;font-weight:700;color:#ce0000;font-size:14px">
                   <i class="iconfont icon-yuandianxiao" style="color:green;font-size:16px"></i> ASIN
                </div>
                <div  id="asinRadar" ></div>
            </div>
            <div style=" width:50%;display:flex">
                <div style="margin-top:100px;text-align:right;width:200px;font-weight:700;color:#ce0000;font-size:14px">
                   <i class="iconfont icon-yuandianxiao" style="color:blue;font-size:16px"></i> SKU
                </div>
                <div  id="skuRadar" ></div>
            </div>
        </div>
        <div style=" display:flex; width:100%; line-height:30px;height:30px;margin-top:2px; background:#808695;color:white ;border-left:3px solid #409eff">
            
            <span style="font-size:12px;margin-left:6px;font-weight:600"> 目标（预测）利润</span>
 
         </div>
         <el-table  :data="tarData" 
              border                            
              size="small"
              :height="90" 
              :cell-style="{padding:'2px'}"
              ref="reftar"
              class="custom-table-border"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" fixed width="70"></el-table-column>
            <span v-for="(item ) in tarCol" :key="item.key" > 
                <el-table-column  v-if="item.thide==='N' "
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
            </span> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <i class="iconfont icon-bianji" style="color:#409eff;font-size:14px; "></i>
                    <el-link  @click="editRec(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px;margin-right:2px;color:#409eff;">编辑</span></el-link>
                  
                </template>
            </el-table-column>  
        </el-table>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 预测表单 -->
        <el-dialog v-dialogDrag :visible.sync="preWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false"  >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预测数据</span>
            </div> 
            <Form  :model="preRow" :label-width="120"  label-position="right" inline >
                <span v-for="(item,index) in tarCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                          
                        <el-input-number @change="numChg" :disabled="item.disabled==='Y'?true:false " controls-position="right" v-if="item.edcss==='number'"  style="width:100%" v-model="preRow[item.key]"></el-input-number> 
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false "  v-model="preRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="preWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="preSave" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="skuWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false"  >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">sku资料</span>
            </div> 
            <Form  :model="skuRow" :label-width="120"  label-position="right" inline >
                <span v-for="(item,index) in skuCol" :key="index" >
                    <FormItem :class="item.key=='MATDESC'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-input type="number" :disabled="item.disabled==='Y'?true:false "  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-if="item.edcss=='number' "  v-model="skuRow[item.key]"   style="width:100%"></el-input>  
                        
                        <el-input :placeholder="item.holder" type="text" v-else  disabled   v-model="skuRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="skuWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="skuSave" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>     
</template>

<script>
  import { getDate} from '../../api/Select' 
  import { getTabColOrData,getBaseData } from '../../api/user'
  export default {
    name: 'sku_profit',
 
    data() {
      return {
          loadWin:false,
          skuno:'',
          asinno:'',
          preWin:false,
          preRow:{},
          matno:'',
        promptWin:false,
        v_row:{} ,
        v_index:0,
        prompt:'',
        skuWin:false,
        skuRow:{},
        formCol:{}, //表格单行记录 model
        subData:[] , //树结构数据
        oper:'like',
        selparam:'CNAME',
        txtparam:'',
        tarCol:[],
        operArr:[],
        tarData:[],
        skuData:[],
        tabData:[],
        tabCol:[],
        skuCol:[],
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        v_authurl:'xuper_auth/getTableRecMany', //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        v_sku:'',
        skuChart: {
            title: '',
            position: ['15%' ,'8%'],
            center: [ '60%','50%'],
            indicator: [
                {text: '采购成本'},
                {text: '财务、管理费'},
                {text: '广告费率（预测）'},
                {text: '平台费'},
                {text: '仓储费'},
                {text: 'FBA运费'},
                {text: '销售佣金'},
                {text: '头程运费'},
                {text: '退货成本'}
            ],
            data: [
                {
                    name: '',
                    color: '#D9006C',
                    value: []
                },
 
            ]
        },
        asinData: {
            title: '',
            position: ['15%' ,'8%'],
            center: [ '60%','50%'],
            indicator: [
                {text: '采购成本'},
                {text: '财务、管理费'},
                {text: '广告费率（平均）'},
                {text: '平台费'},
                {text: '仓储费'},
                {text: 'FBA运费'},
                {text: '销售佣金'},
                {text: '头程运费'},
                {text: '退货成本'}
            ],
            data: [
                {
                    name: '',
                    color: '#019858',
                    value: []
                },
 
            ]
        },
      }
    },
    watch: {
 
    },
    created () {
        if(this.v_username){
            // this.frdttm =getDate('yr')+'-01-01'
            // this.todttm=getDate('day')
            this.getTabField() // 字段集
           
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.qryTabData()
        //this.asinCharts()
        //this.skuCharts()
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 128) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 90) + 'px';
            }, 
            tabWidth: function() {
                return (window.innerWidth - 140) + 'px';
            }, 
        },
    methods: {
        //sku 实际广告费 ,头程运费
        skuSave(){
            let v_cond =' set actadv=\''+this.skuRow['ACTADV']+'\',FIRSTFEE=\''+this.skuRow['FIRSTFEE']+'\''
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_row['IDSEQ'],p_table:'sku_cost',p_cond:v_cond },
            }).then(res=>{ 
                if (res.code!=='200'){
                    this.promptWin =true
                    this.prompt =res.result
                }else {
                    this.skuData.splice(this.v_index,1,Object.assign(this.v_row,{ACTADV:this.skuRow['ACTADV'],FIRSTFEE:this.skuRow['FIRSTFEE']}))
                    this.skuWin =false
                }
            })
        },
        editSku(row,index){
            this.v_index =index
            this.v_row =JSON.parse(JSON.stringify(row))
            this.skuWin =true
            this.skuRow =JSON.parse(JSON.stringify(row))
        },
        numChg(){
            let v_prc =!this.preRow['PREPRC']?'0':this.preRow['PREPRC']
            let v_pocost =!this.preRow['POCOST']?'0':this.preRow['POCOST']
            let v_firstfee =!this.preRow['FIRSTFEE']?'0':this.preRow['FIRSTFEE']
            let v_amzpct =!this.preRow['AMZPCT']?'0':this.preRow['AMZPCT']
            let v_fbafee =!this.preRow['FBAFEE']?'0':this.preRow['FBAFEE']

            let v_stkfee =!this.preRow['STKFEE']?'0':this.preRow['STKFEE']
            let v_platfee =!this.preRow['PLATPCT']?'0':this.preRow['PLATPCT']
            let v_advfee =!this.preRow['ADVPCT']?'0':this.preRow['ADVPCT']
            let v_rtnfee =!this.preRow['RTNPCT']?'0':this.preRow['RTNPCT']
            let v_gross=(Number(v_prc)-Number(v_pocost)-Number(v_firstfee)-Number(v_amzpct)-Number(v_fbafee)
                        -Number(v_stkfee)-Number(v_platfee)-Number(v_advfee)-Number(v_rtnfee) ).toFixed(2)
            console.log('v_gross:'+v_gross)
            let v_gropct= (v_gross/Number(v_prc)*100).toFixed(2)
            Object.assign(this.preRow,{GSAMT:v_gross,GSPCT: v_gropct})                        
        },
        editRec(row,index){
            this.v_sku =row['SKU']
            this.preWin=true
            this.preRow=JSON.parse(JSON.stringify(row))
        },
        //新增预测记录
        addRec(row,index){
            setTimeout(() => {
                if (this.tarData.length>0){
                    this.promptWin =true
                    this.prompt ='SKU下已存在预测记录'
                }else{
                    this.preRow={}
                    this.v_sku =row['SKU']
                    this.preWin =true
                    this.preRow={IDSEQ:'',SKU:row['SKU'],MATNO:row['MATNO'],MATDESC:row['SKUDESC'],ASIN:row['ASIN'],POCOST:row['POCOST'],
                        FIRSTFEE:row['FIRSTFEE'],FBAFEE:row['FBAFEE'],STKFEE:row['STKFEE'],AMZPCT: row['SALECOMM'] 
                        ,PLATPCT: row['PLATFEE'] ,ADVPCT: row['ADVERFEE'] ,CORPID:this.v_corpid,ACTADV:row['ACTADV']
                        ,RTNPCT: row['RTNCOST'] 
                    }
                }         
            }, 400);    
        },
        preSave(){
            this.$axios({
                method: 'post',
                url:'xuper_auth/formOneSave',
                data: {p_json:JSON.stringify(this.preRow), p_table:'SKU_PRETEST',p_frmid:''},
            }).then(res=>{ 
                this.getPreData(this.v_sku)
                this.preWin =false
            })
        },
        //asin 雷达图
        skuCharts(){
            let seriesData = []
            this.skuChart.data.forEach(item => {
                seriesData.push(
                    {
                        value: item.value,
                        name: item.name,
                        symbol: 'none',
                        symbolSize: 5,
                        itemStyle:{
                            color:item.color
                        },
                        lineStyle: {
                            normal: {
                                color:item.color,
                                width:1,
                            },
                            emphasis:{
                                width:2,
                            }
                        }
                    }
                )
            })
            //splitLine：分割线修改样式的属性，axisLine：射线修改样式的属性，splitArea：分割区域的样式，lineStyle：带有数的线样式修改
            const  option ={
                tooltip: {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
 
                legend:{
                    data: this.skuChart.data.map(item => {return {name:item.name,icon:'circle'}}),
                    left:"390px",
                    bottom: '0px',
                    itemWidth:10,
                    itemHeight:10,
                    itemGap:10,
                    textStyle:{
                        color:'#409eff',
                        fontSize:12
                    }
                },
                radar:{
                    indicator: this.skuChart.indicator,  //指示器的名称
                    center: this.skuChart.center,
                    radius: "82%",
                    //startAngle: 90,
                    splitNumber: 5,  //里面有几个圆
                    //设置雷达图中间射线的颜色
                    axisLine:{
                        lineStyle:{
                            color: '#ccc',
                            fontSize:30
                        }
                    },
 
                    //shape: 'circle', //原型是六边形，加了该字段为圆形
                    name: {
                        textStyle: {
                            color:'#336666',
                            fontSize:12,
                            fontWeight:700
                        }
                    },
                    nameGap:10,
                    splitArea: {  //雷达背景图的颜色
                        areaStyle: {
                            color: ['#e0e0e0','#fff'],
                            //shadowColor: 'rgba(0, 0, 0, 0.3)',
                            //shadowBlur:10
                        }
                    },
 
                    splitLine: { //里面5个圈线条颜色
                        show:false,
                        lineStyle: {
                            color: 'red'
                        }
                    }
                },
                series:{
                    name: 'SKU 费用占比',
                    type: 'radar',
                    itemStyle: {
                        emphasis: {
                            // color: 各异,
                            lineStyle: {
                                width: 4
                            }
                        }
                    },
                    data: seriesData
                }
            }
            //option.legend.left='10%';
            let myChart = this.$echarts.init(document.getElementById("skuRadar"));
            myChart.clear();
            myChart.resize(
                {
                    width:'450',
                    height:'250px'
                }
            )
            myChart.setOption(option)
        },
        //asin 雷达图
        asinCharts(){
            let seriesData = []
            this.asinData.data.forEach(item => {
                seriesData.push(
                    {
                        value: item.value,
                        name: item.name,
                        symbol: 'none',
                        symbolSize: 5,
                        itemStyle:{
                            color:item.color
                        },
                        lineStyle: {
                            normal: {
                                color:item.color,
                                width:1,
                            },
                            emphasis:{
                                width:2,
                            }
                        }
                    }
                )
            })
            //splitLine：分割线修改样式的属性，axisLine：射线修改样式的属性，splitArea：分割区域的样式，lineStyle：带有数的线样式修改
            const  option ={
                tooltip: {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title:{
                    // text:this.data.title,
                    // bottom:"5%",
                    // left:this.data.position[0],
                    // textStyle:{
                    //     color:'#fff',
                    //     fontSize:12,
                    // }
                },
                legend:{
                    data: this.asinData.data.map(item => {return {name:item.name,icon:'circle'}}),
                    left:"390px",
                    bottom: '0px',
                    itemWidth:10,
                    itemHeight:10,
                    itemGap:10,
                    textStyle:{
                        color:'#409eff',
                        fontSize:12
                    }
                },
                radar:{
                    indicator: this.asinData.indicator,  //指示器的名称
                    center: this.asinData.center,
                    radius: "82%",
                    //startAngle: 90,
                    splitNumber: 5,  //里面有几个圆
                    //设置雷达图中间射线的颜色
                    axisLine:{
                        lineStyle:{
                            color: '#ccc',
                            fontSize:30
                        }
                    },
 
                    //shape: 'circle', //原型是六边形，加了该字段为圆形
                    name: {
                        textStyle: {
                            color:'#336666',
                            fontSize:12,
                            fontWeight:700
                        }
                    },
                    nameGap:10,
                    splitArea: {  //雷达背景图的颜色
                        areaStyle: {
                            color: ['#e0e0e0','#fff'],
                            //shadowColor: 'rgba(0, 0, 0, 0.3)',
                            //shadowBlur:10
                        }
                    },
 
                    splitLine: { //里面5个圈线条颜色
                        show:false,
                        lineStyle: {
                            color: 'red'
                        }
                    }
                },
                series:{
                    name: 'ASIN 费用占比',
                    type: 'radar',
                    itemStyle: {
                        emphasis: {
                            // color: 各异,
                            lineStyle: {
                                width: 4
                            }
                        }
                    },
                    data: seriesData
                }
            }
            //option.legend.left='10%';
            let myChart = this.$echarts.init(document.getElementById("asinRadar"));
            myChart.clear();
            myChart.resize(
                {
                    width:'450',
                    height:'250px'
                }
            )
            myChart.setOption(option)
        },
        refData(){  
            this.$confirm('你确定要刷新数据吗,可能需要等待40秒左右','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin=true
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/refreshAmzCost',
                    data: { 'corpid' :this.v_corpid  },
                }).then(res=>{ 
                    this.loadWin=false
                    this.qryTabData()
                })
            }).catch(()=>{})
        },
        //查询  //历史毛利明细
        qryTabData(){
            this.loadWin=true
                //1、真实毛利明细
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'corpid', p_value:this.v_corpid,p_cond:' and lower(sku) like lower(\'%'+this.skuno+'%\') AND lower(matno) like lower(\'%'+this.matno+'%\') and lower(asin) like lower(\'%'+this.asinno+ '%\')  ',p_table:'V_SKU_cost'},
                }).then(res=>{ 
                    this.tabData=res.result
                    this.loadWin=false
                    this.$refs['refsum'].doLayout()
                    this.skuData=[]
                    this.$nextTick(()=>{
                        if (res.result.length>0) {
                            this.$refs['refsum'].setCurrentRow(res.result[0])
                            this.getSkuData(res.result[0]['ASIN'] )
                            
                        }
                    })
                })
   
        },
        getRowKey(row){
            return row.IDSEQ
        },
       
        rowClick(row ){
            this.getSkuData(row['ASIN'] )   
       
        },
        skuClick(row){
            this.getPreData(row['SKU'])
            this.skuChart.data[0].value =[row['POCOST'],'0',row['ADFEE'],row['PLATFEE'],row['STKFEE'],row['FBAFEE'],row['SALECOMM'],row['FIRSTFEE'],row['RTNCOST']]
            this.skuCharts()
 
        },
        // sku 店铺经营数据
        getSkuData(asin ) {   
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid,p_key2:'asin',p_value2:asin ,p_table:'V_SKU_cost'},
            }).then(res=>{ 
                this.skuData=res.result
                this.$refs['refsku'].doLayout()
                this.tarData=[]
                this.$nextTick(()=>{
                    if (res.result.length>0){
                        let obj =res.result[0]
         
                        this.$refs['refsku'].setCurrentRow(obj)
                        this.skuChart.data[0].value =[obj['POCOST'],obj['MGTFEE'],obj['ADFEE'],obj['PLATFEE'],obj['STKFEE'],obj['FBAFEE'],obj['SALECOMM'],obj['FIRSTFEE'],obj['RTNCOST']]
                        this.skuCharts()
                        this.asinRardar(obj['ASIN'])
                        //预测记录
                        this.getPreData(res.result[0]['SKU'])
                    }

                })             
            })                            
        },
        // sku 预测数据
        getPreData(sku) {   
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid,p_key2:'sku',p_value2:sku,p_table:'V_SKU_PRETEST'},
            }).then(res=>{ 
                this.tarData=res.result
                this.$refs['reftar'].doLayout()
                this.$nextTick(()=>{
                    if (res.result.length>0){
                        let obj =res.result[0]
                        this.$refs['reftar'].setCurrentRow(obj)
                    }
                })             
            })                            
        },
        asinRardar(asin){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: {p_cond:'SELECT b.asin, max(a.prc) prc,max(a.PLATFEE) PLATFEE,sum(a.ADVERFEE) ADFEE,sum(a.STKFEE) STKFEE,sum(a.FBAFEE) FBAFEE,'+
                            'sum(A.SALECOMM) SALECOMM,MAX(A.RTNCOST) RTNCOST,sum(A.FIRSTFEE) FIRSTFEE,sum(A.MGTFEE) MGTFEE,max(a.pocost) pocost,max(a.grosspct) grosspct '+
                            'FROM V_SKU_cost a,V_AMZ_MATDTL b WHERE a.corpid=b.corpid and a.sku=b.sku and  a.CORPID=\''+this.v_corpid+'\''+
                            '  and lower(b.asin) = lower(\''+asin+'\') GROUP BY b.asin' },
            }).then(res=>{ 
                if (res.result.length>0){
                    let obj=res.result[0]
                    this.asinData.data[0].value =[obj['POCOST'],obj['MGTFEE'],obj['ADFEE'],obj['PLATFEE'],obj['STKFEE'],obj['FBAFEE'],obj['SALECOMM'],obj['FIRSTFEE'],obj['RTNCOST']]
                    this.asinCharts()
                }
            }) 
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(vm.v_authurl, 'v_sys_form_fld','idseq','17348','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_authurl, 'v_sys_form_fld','idseq','17348','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.skuCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_authurl, 'v_sys_form_fld','idseq','17348','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tarCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped>
 
    .item-width  {
        width: 32%;
    } 
    .item-width2  {
        width: 97%;
    } 
 
  
    .border-right{
        border-right:1px solid #409eff;
    }        
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
